import { Box } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const TypingIndicator = () => (
  <Box sx={styles.container}>
    <Box sx={styles.avatar}>
      <StarIcon sx={{ fontSize: 16, color: "#fff" }} />
    </Box>
    <Box sx={styles.dots}>
      {[0, 1, 2].map((i) => (
        <Box key={i} sx={{ ...styles.dot, animationDelay: `${i * 0.2}s` }} />
      ))}
    </Box>
  </Box>
);

export default TypingIndicator;

const styles = {
  container: { display: "flex", gap: "10px", mb: "16px", animation: "ginoSlideUp 0.3s ease forwards", "@keyframes ginoSlideUp": { from: { opacity: 0, transform: "translateY(12px)" }, to: { opacity: 1, transform: "translateY(0)" } } },
  avatar: { width: 32, height: 32, background: "#106048", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
  dots: { background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "16px", padding: "14px 20px", display: "flex", gap: "5px", alignItems: "center" },
  dot: { width: 7, height: 7, background: "#106048", borderRadius: "50%", animation: "ginoTypingBounce 1.2s infinite", "@keyframes ginoTypingBounce": { "0%, 100%": { transform: "translateY(0)", opacity: 0.4 }, "50%": { transform: "translateY(-5px)", opacity: 1 } } },
};
